import module from 'fan/proyecto/module.js'
import template from './template.html'
import { element } from 'angular'
import './style.scss'

export class FanPlantillasEditorComponent {
  placeholders = []
  contenido = ''
  onChange = null
  editor = null

  constructor ($element, $scope, $window) {
    this.$element = $element
    this.$scope = $scope
    this.$window = $window
    this.window = element($window)
    this.onResize = this.resize.bind(this)
  }

  $onInit () {
    this.iniciar()
  }

  $onDestroy () {
    this.terminar()
  }

  iniciar () {
    this.editor = this.$window.CKEDITOR.replace('editor', {
      stylesSet: [
        {name: 'Título', element: 'h1', styles: {'text-align': 'center'}},
      ],
      format_tags: 'h1;h2;h3;p',
      bodyClass: 'document-editor',
      allowedContent: 'h1 h2 h3 blockquote strong ol ul li hr table tr td tbody div; *[*]; *{*}; *(*);',
      removeButtons: 'PasteFromWord,PasteText,Paste,Copy,Cut,Placeholder',
      language: 'es-mx',
      extraPlugins: 'placeholder_select,pagebreak',
      placeholder_select: {
        placeholders: this.placeholders || [],
        format: '[[%placeholder%]]',
      },
    })

    this.editor.on('mode', () => {
      if (this.editor.mode === 'source') {
        this.editor.editable().attachListener(this.editor.editable(), 'input', () => {
          this.$scope.$apply(() => {
            this.contenido = this.editor.getData()
            this.actualizar()
          })
        })
      }
    })

    this.editor.on('change', () => {
      this.$scope.$apply(() => {
        this.contenido = this.editor.getData()
        this.actualizar()
      })
    })

    this.editor.once('instanceReady', () => {
      this.window.on('resize', this.onResize)
      this.resize()
    })
  }

  actualizar () {
    this.onChange({$event: {data: {contenido: this.contenido}}})
  }

  resize () {
    let height = this.window[0].innerHeight
    let offset = 0
    let element = this.$element[0]

    while (element && !isNaN(element.offsetLeft) && !isNaN(element.offsetTop)) {
      offset += element.offsetTop - element.scrollTop
      element = element.offsetParent
    }

    requestAnimationFrame(() => {
      if (this.editor) {
        this.editor.resize(this.editor.config.width, height - offset)
      }
    })
  }

  terminar () {
    this.window.off('resize', this.onResize)

    if (this.editor) {
      this.editor.destroy()
    }
  }
}

module.component('fanPlantillasEditor', {
  controller: FanPlantillasEditorComponent,
  template: template,
  bindings: {
    placeholders: '<',
    contenido: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/plantillas/components/editor/component.js